export default {
  color: 'primary',
  textColor: 'primary',
}